import mixpanel from "../services/mixpanel";
import Raven from "../services/raven";

export const ErrorReporter = store => next => action => {
  if (action.error) {
    Raven.captureException(action.error);
    //track error in mixpanel
    mixpanel.track(action.type, { errorMsg: action.error });
  }
  next(action);
};



// WEBPACK FOOTER //
// ./src/middleware/ErrorReporter.js